module.exports = __webpack_public_path__ + "img/039-balloon.b565773e.png";